const noteBoxTypes = {
  calendar: 1,
  foodlog: 2,
  bodyStats: 7,
  lifestyleHabits: 9,
  nutritionHabits: 10,
  workoutHabits: 11,
  programmingNotes: 12,
  rapportNotes: 13,
  callLog: 14,
  retentionNotes: 15,
  struggles: 16,
  wins: 18,
  moments: 17,
  currentInjuries: 19,
  goals: 20,
  kryptonite: 21,
  miscLinksNotes: 22,
  superpowers: 23,
  equipment: 24,
  healthNotes: 25,
  quickSummary: 26,
  family: 27,
  alternateInfo: 28,
  privateChurnNotes: 29,
  churnThreatNotes: 30,
  renewalEmail: 31,
  salesNotes: 32,
};

const mapTypeToLabels = new Map([
  [noteBoxTypes.foodlog, { shortLabel: 'Food' }],
  [noteBoxTypes.bodyStats, { shortLabel: 'Body' }],
  [noteBoxTypes.lifestyleHabits, { shortLabel: 'Life' }],
  [noteBoxTypes.nutritionHabits, { shortLabel: 'Nutr' }],
  [noteBoxTypes.workoutHabits, { shortLabel: 'Work' }],
  [noteBoxTypes.programmingNotes, { shortLabel: 'Prog' }],
  [noteBoxTypes.rapportNotes, { shortLabel: 'Rapp' }],
  [noteBoxTypes.retentionNotes, { shortLabel: 'Ret' }],
  [noteBoxTypes.struggles, { shortLabel: 'Str' }],
  [noteBoxTypes.wins, { shortLabel: 'Win' }],
  [noteBoxTypes.moments, { shortLabel: 'Mom' }],
  [noteBoxTypes.currentInjuries, { shortLabel: 'Inj' }],
  [noteBoxTypes.kryptonite, { shortLabel: 'Krypt' }],
  [noteBoxTypes.miscLinksNotes, { shortLabel: 'Misc' }],
  [noteBoxTypes.superpowers, { shortLabel: 'Super' }],
  [noteBoxTypes.equipment, { shortLabel: 'Equip' }],
  [noteBoxTypes.healthNotes, { shortLabel: 'Health' }],
  [noteBoxTypes.quickSummary, { shortLabel: 'Quick' }],
  [noteBoxTypes.family, { shortLabel: 'Fam' }],
  [noteBoxTypes.alternateInfo, { shortLabel: 'Alt' }],
]);

export { mapTypeToLabels, noteBoxTypes };
